export default "__VITE_ASSET__VEzN$0oN__"